import styled from 'styled-components';

export const LegalContainer = styled.main`
  padding: 120px 5% 60px;
  max-width: 900px;
  margin: 0 auto;

  @media (max-width: 768px) {
    padding: 100px 5% 40px;
  }
`;

export const LegalHeader = styled.header`
  margin-bottom: 2rem;
  text-align: center;
`;

export const LegalTitle = styled.h1`
  font-size: 2.5rem;
  font-weight: 700;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

export const LegalContent = styled.div`
  line-height: 1.8;

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-top: 2rem;
    margin-bottom: 1rem;
    font-weight: 600;
  }

  h1 {
    font-size: 2rem;
  }

  h2 {
    font-size: 1.75rem;
  }

  h3 {
    font-size: 1.5rem;
  }

  p {
    margin-bottom: 1rem;
  }

  ul,
  ol {
    margin-bottom: 1rem;
    padding-left: 2rem;
  }

  li {
    margin-bottom: 0.5rem;
  }

  a {
    color: var(--primary);
    text-decoration: underline;
  }
`;
